import React from 'react';
import PropTypes from 'prop-types';

import {
  Flex,
  Label,
  Modal,
  CreatableSelect
} from '@ubisend/pulse-components';

const TagModal = ({
  tags,
  header,
  onCancel,
  isVisible,
  onConfirm,
  selectedTags,
  handleTagChange
}) => {
  if (!isVisible) {
    return null;
  }

  return (
    <Modal
      header={header}
      handleCancel={onCancel}
      handleConfirm={onConfirm}
      confirmText="Assign"
      cancelText="Cancel"
      body={
        <Flex col gap="sm">
          <Label htmlFor="tagSelect">Available Tags</Label>
          <CreatableSelect
            id="tagSelect"
            closeMenuOnSelect={false}
            isMulti
            isClearable
            value={selectedTags.map(tagId => ({
              label: tags.find(tag => tag.id === tagId)?.name || '',
              value: tagId
            }))}
            onChange={handleTagChange}
            options={tags.map(tag => ({ label: tag.name, value: tag.id }))}
            placeholder="Select tags to assign"
          />
        </Flex>
      }
    />
  );
};

TagModal.propTypes = {
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    })
  ).isRequired,
  header: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  isVisible: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  selectedTags: PropTypes.arrayOf(PropTypes.string).isRequired,
  handleTagChange: PropTypes.func.isRequired
};

export default TagModal;